(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    const targets = [...root.querySelectorAll('[data-gb-enter]')];
    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('gb-motion-ready');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('gb-enter-pending');
        entry.target.classList.add('gb-entered');
        observer.unobserve(entry.target);
      }), { threshold: 0.08 });
      targets.forEach((target, index) => {
        if (target.dataset.gbObserved) return;
        target.dataset.gbObserved = 'true';
        if (target.getBoundingClientRect().top < innerHeight) return;
        target.classList.add('gb-enter-pending');
        target.style.transitionDelay = `${Math.min(index % 4 * 55, 165)}ms`;
        observer.observe(target);
      });
      reducedMotion.addEventListener('change', event => {
        if (event.matches) targets.forEach(target => target.classList.remove('gb-enter-pending'));
      }, { once: true });
    }
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
